export const GET_COMPANY_NEWS = "GET_COMPANY_NEWS";
export const GET_HOME_NEWS = "GET_HOME_NEWS";
export const SET_CURRENT_NEWS_TYPE_LABEL = "SET_CURRENT_NEWS_TYPE_LABEL";

export default {
  GET_COMPANY_NEWS,
  GET_HOME_NEWS,
  SET_CURRENT_NEWS_TYPE_LABEL
};
